import { formatDateToString } from "../../../../util/dateFormat";
import { getDateStringVN } from "../../utils/DateTimeUtils";
import { tienFormat } from "../../utils/NumberUtils";
import _ from 'lodash'
import Decimal from "decimal.js";
import { MessageReport } from "../../db/report/totalReport";
/*Thứ…, ngày… Khách
Tên khách
MN: 2C…da…dx… 3C…4C… (tiền qua cò)
Trúng: 2C… da…dx…3C…4C…(tiền trúng)
(Nếu là chuyển cho Chủ)
Thu = Lãi hay Bù = Lỗ * 0.95
(Nếu là nhận của khách)
Thu = Lãi * 0.95 hay Bù = Lỗ
*/
export const templete1_details: { [key: string]: string } = {
    "6Lo2c": "2C",
    "DKC": "2C",
    '6Lo3C': '3C',
    '7Lo2C': '2C',
    '8Lo2C': '2C',
    '7Lo3C': '3C',
    'DaT': 'da',
    'Dau2C': '2C',
    'Dau4C': '4C',
    'DaX': 'dx',
    'Duoi2C': '2C',
    'Duoi4C': '4C',
    'Lo2C': '2C',
    'Lo3C': '3C',
    'Lo4C': '4C',
    'XC': '3C',
    'XcDau': '3C',
    'XcDuoi': '3C',
    'Xi2': 'XMB',
    'Xi3': 'XMB',
    'Xi4': 'XMB',
}
export const templete1_total = {
    message: {} as any,
    MIEN: '',
    NGAY: '',
    //Qua cò
    QuaCo: {
        '2C': 0,
        '3C': 0,
        '4C': 0,
        'da': 0,
        'dx': 0,
        'XMB': 0
    } as { [key: string]: number },
    //Qua cò
    TienTrung: {
        '2C': 0,
        '3C': 0,
        '4C': 0,
        'da': 0,
        'dx': 0,
        'XMB': 0
    } as { [key: string]: number },
    GetLaiLo: function () {
        return this.QuaCo['2C'] + this.QuaCo['3C'] + this.QuaCo['4C'] + this.QuaCo['da'] + this.QuaCo['dx'] + this.QuaCo['XMB']
            - (this.TienTrung['2C'] + this.TienTrung['3C'] + this.TienTrung['4C']
                + this.TienTrung['da'] + this.TienTrung['dx'] + this.TienTrung['XMB'])
    },
    GetSMS: function () {
        let sms = "";// "Ngay:" + this.NGAY + "\r\n"
        sms += this.MIEN + ":"
        if (this.QuaCo['2C'] != 0) {
            sms += `2c=${tienFormat(this.QuaCo['2C'], 1)}n\r\n`
        }
        if (this.QuaCo['da'] != 0) {
            sms += `da=${tienFormat(this.QuaCo['da'], 1)}n\r\n`
        }
        if (this.QuaCo['dx'] != 0) {
            sms += `dx=${tienFormat(this.QuaCo['dx'], 1)}n\r\n`
        }
        if (this.QuaCo['3C'] != 0) {
            sms += `3c=${tienFormat(this.QuaCo['3C'], 1)}n\r\n`
        }
        if (this.QuaCo['4C'] != 0) {
            sms += `4c=${tienFormat(this.QuaCo['4C'], 1)}n\r\n`
        }
        if (this.QuaCo['XMB'] != 0) {
            sms += `XMB=${tienFormat(this.QuaCo['XMB'], 1)}n\r\n`
        }//tien thuong
        let tmp = ""
        if (this.TienTrung['2C'] != 0) {
            tmp += `2c=${tienFormat(this.TienTrung['2C'], 1)}n\r\n`
        }
        if (this.TienTrung['da'] != 0) {
            tmp += `da=${tienFormat(this.TienTrung['da'], 1)}n\r\n`
        }
        if (this.TienTrung['dx'] != 0) {
            tmp += `dx=${tienFormat(this.TienTrung['dx'], 1)}n\r\n`
        }
        if (this.TienTrung['3C']! + 0) {
            tmp += `3c=${tienFormat(this.TienTrung['3C'], 1)}n\r\n`
        }
        if (this.TienTrung['4C'] != 0) {
            tmp += `4c=${tienFormat(this.TienTrung['4C'], 1)}n\r\n`
        }
        if (this.TienTrung['XMB'] != 0) {
            tmp += `XMB=${tienFormat(this.TienTrung['XMB'], 1)}n\r\n`
        }
        if (tmp != "") {
            sms += "\r\nTrúng:" + tmp
        }
        const laiLo = this.GetLaiLo()
        if (laiLo > 0) {
            sms += "\r\nThu:" + tienFormat(laiLo, 1)
        } else if (laiLo < 0) {
            sms += "\r\nBù:" + tienFormat(laiLo, 1)
        } else {
            sms += "\r\nHoà"
        }
        sms += "\r\n-----\r\n"
        return sms;
    }
}
export function GetTotalLaiLoText(data: MessageReport): string {
    let tienHoi = TinhTienHoi(data)
    if (data.isTotalAllContact) {
        let text = data.laiLoToanBo > 0 ? "Thu:" + tienFormat(data.laiLoToanBo, 1) :
            (data.laiLoToanBo < 0 ? "Bù:" : "") + tienFormat(data.laiLoToanBo, 1)
        console.log("GetTotalLaiLoText", text)
        return text
    }
    let laiLo = ""
    if (data.laiLo == 0)
        return ""
    let text = data.laiLo > 0 ? "Thu:" :
        (data.laiLo < 0 ? "Bù:" : "")
    if (data.phanTramThau == 0)
        laiLo = text + tienFormat(data.laiLo, 1)
    else {
        laiLo = text + tienFormat(data.laiLo, 1) + "x" + (100 - data.phanTramThau) + "% = " +
            tienFormat(data.laiLo / 100 * (100 - data.phanTramThau), 1)
    }
    if (tienHoi != 0) {

        let totalLaiLo = data.laiLoToanBo
        laiLo += ` hồi ${tienFormat(tienHoi, 1)}=${tienFormat(totalLaiLo, 1)}`
    }
    return laiLo
}
/*Mẫu 2*/
export function getSMSMau1(messages1: any) {
    const messages = Array.isArray(messages1) ? messages1 : (messages1 ? [messages1] : []);
    let smss: typeof templete1_total[] = [];
    let ngay = ""
    let ten = ""
    let phanTramThau = 0
    messages && messages.length > 0 && messages.map((msg: any) => {
        let mien = "MN";
        if (msg.key == 1)
            mien = "MB";
        if (msg.key == 2)
            mien = "MT";

        let curSms: typeof templete1_total = _.cloneDeep(templete1_total);
        curSms.message = msg;
        ngay = getDateStringVN(msg.date)
        curSms.MIEN = mien;
        ten = msg.contactName;
        phanTramThau = msg.phanTramThau
        smss.push(curSms);
        msg.children && msg.children.map((group: any) => {
            group.children && group.children.map((item: any) => {
                const loaiCuocId: string = item.loaiCuocId;
                const groupId: string = templete1_details[loaiCuocId];
                curSms.QuaCo[groupId] += item.quaCo
                curSms.TienTrung[groupId] += item.thuong
            })
        })
    })
    let zSms = "Ngày:" + ngay + ". " + ten + "\r\n"
    let laiLo = 0;
    let tienHoiSauPt = 0
    smss.forEach(sms => {
        zSms += sms.GetSMS()
        laiLo += sms.GetLaiLo()
        tienHoiSauPt += TinhTienHoi(sms.message)
    })
    const laiLoSauPt = laiLo / 100 * (100 - phanTramThau)
    if (messages.length > 1) {
        if (laiLo > 0) {
            zSms += "\r\nTổng cộng thu:" + GetLaiLoByPhanTramThau(laiLo, phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else if (laiLo < 0) {
            zSms += "\r\nTổng cộng bù:" + GetLaiLoByPhanTramThau(laiLo, phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else {
            zSms += "\r\nTổng cộng hoà"
        }
    }
    console.log(zSms)
    return zSms;
}
export function GetLaiLoByPhanTramThau(laiLo: number, phanTramThau: number) {
    if (phanTramThau == 0)
        return tienFormat(laiLo, 0)
    else {
        let sLaiLo = tienFormat(laiLo, 0)
        let sTotal = tienFormat(laiLo / 100 * (100 - phanTramThau))
        let result = sLaiLo + "x" + (100 - phanTramThau) + "% = " + sTotal
        return result
    }
}
export function TinhTienHoi(message0: any): number {
    let result = 0
    result = message0.tienHoi
    result = result / 100 * (100 - message0.phanTramThau)
    return result;
}
export function TinhTienLaiSauHoiText(message0: any): string {
    const tienHoi = TinhTienHoi(message0);
    let result = ""
    result = ((message0.laiLo > 0 ? "Thu: " : (message0.laiLo < 0 ? "Bù: " : "")) +
        GetLaiLoByPhanTramThau(message0.laiLo, message0.phanTramThau))
    if (tienHoi != 0) {
        result += `\r\nhồi ${tienFormat(tienHoi, 1)}=${tienFormat(message0.laiLoToanBo)}`
    }
    return result;
}
export function TinhTienLaiSauHoi(message0: any): number {

    return message0.laiLoToanBo;
}
export function DecimalAdd(a: number, b: number): number {
    return new Decimal(a).plus(b).toNumber();
}
export function GetTextTienHoi(totalLai: number, totalHoi: number): string {

    let result = ""
    if (totalHoi != 0) {
        result += `\r\nhồi ${tienFormat(totalHoi, 1)}=${tienFormat(totalLai - totalHoi)}`
    }
    return result;
}